/* eslint-disable */
import React from 'react'

import { Spacer, Button, Divider } from '@cleartrip/bento'

import { isEmpty } from 'AccountsUtils'
import OfflineToast from '../offlineToast'
import { SVGComponent } from '../..'
import Icon from '../../../icons/flipkart.png'
import { linkAccounts, saveNudge } from '../../../pages/Trips/trips.helper'

import USER_PROFILE_PAGE_CONTANTS from '../UserProfileConstants'

const LinkAccounts = ({
  handleLinkClick,
  toggle,
  setPageName,
  email,
  toggleModalAndClosePage
}) => {
  const redirect = () => {
    if (isEmpty(email)) {
      setPageName(USER_PROFILE_PAGE_CONTANTS.PERSONAL_DETAILS)
    } else {
      toggleModalAndClosePage()
    }
  }
  const linkAccountsHandler = async () => {
    const response = await linkAccounts()
    const { status } = response
    if (status === 200) {
      setPageName(USER_PROFILE_PAGE_CONTANTS.LINK_SUCCESS)
      redirect()
    } else {
      // add failure page here
      toggleModalAndClosePage()
    }
  }
  const notNowClickHandler = async () => {
    const response = await saveNudge('FK_LINK')

    redirect()
  }
  return (
    <div
      className="bg-white br-4 br-4 o-hidden d-flex flex-column"
      style={{
        width: '400px',
        height: '554px'
      }}
    >
      <div
        className="mb-8 bg-secondary-100 pt-8 pb-6 px-8 br-4"
        style={{
          height: '199px'
        }}
      >
        <div className="d-flex flex-middle">
          <SVGComponent svgIcon="orange_tick_copy" />
          <div className="ml-3 mr-3">
            <SVGComponent svgIcon="link_icon_copy" />
          </div>
          <img src={Icon} height={32} width={32} />
          {/* <FlipkartIcon /> */}
        </div>
        <Spacer className="mt-3" />
        <div
          className="fw-600 fs-6 c-grey-90 lh-copy"
          style={{ padding: '6px 2px 1px' }}
        >
          Cleartrip is now a part of Flipkart family. Link accounts in seconds
          to get extra benefits.
        </div>
        <Spacer className="mt-13" />
      </div>
      <div className="pb-8 px-8">
        <OfflineToast page="link accounts" />
        <div className="d-flex flex-middle">
          <SVGComponent svgIcon="super_coin" height={18} width={18} />
          <div className="c-grey-70 fs-3 ml-3">
            {' '}
            Get unlimited SuperCoin discounts
          </div>
        </div>
        <Spacer className="mt-5" />
        <div style={{ marginBottom: '72px' }} className="d-flex flex-middle">
          <SVGComponent svgIcon="icon_gift_card" height={18} width={18} />
          <div className="c-grey-70 fs-3 ml-3">
            Get personalised benefits and discounts
          </div>
        </div>
        <div className="d-flex flex-column flex-middle">
          <Button
            size="md"
            type="secondary"
            full={true}
            onClick={linkAccountsHandler}
          >
            <span className="fs-3 fw-550">Link and continue</span>
          </Button>
          <div
            className="mt-4 fw-600 fs-3 c-blue c-pointer"
            onClick={notNowClickHandler}
          >
            Not now
          </div>
        </div>
        <Divider className="bc-grey-10 mt-8" />
        <div className="mt-5 d-flex flex-column flex-middle">
          <div>
            <span className="fs-2 c-grey-70">
              By continuing, you agree to give Cleartrip access to your
            </span>
          </div>
          <div>
            <span className="fs-2 c-grey-70">Flipkart information. View </span>
            <span
              className="fs-2 fw-500 c-blue c-pointer"
              onClick={() => handleLinkClick('privacy-policy')}
            >
              {' '}
              privacy policy
            </span>{' '}
            <span className="fs-2 c-grey-70">&</span>{' '}
            <span
              className="fs-2 fw-500 c-blue c-pointer"
              onClick={() => handleLinkClick('terms-of-service')}
            >
              terms of use.
            </span>
          </div>
        </div>
      </div>
    </div>
  )
}

export default LinkAccounts
